import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Title = styled.p(() =>
  mq({
    textAlign: 'center',
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    margin: `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.l}`,
  }),
);

export const ContentWrapper = styled.div(() =>
  mq({
    marginTop: defaultTheme.spacing.m,
    padding: [0, 0, defaultTheme.spacing.l, defaultTheme.spacing.l],
  }),
);

export const DailyOrderLimitLinkArea = styled.div(() =>
  mq({
    textAlign: 'center',
    marginBottom: [
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
    ],
    '& > a': {
      fontSize: defaultTheme.font.size.s,
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
  }),
);

export const ExternalLink = styled.a(() =>
  mq({
    textDecorationLine: 'underline',
    ...hoverOpacity,
  }),
);
